import UniversalRouter from 'universal-router';

import routes, { GlobalRouteParams } from 'src/routes';

export default new UniversalRouter<GlobalRouteParams>(routes, {
  async resolveRoute(context, params) {
    if ('load' in context.route && typeof context.route.load === 'function') {
      const action = await context.route.load();
      return action.default(context, params);
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return undefined;
  },
});
